@if (cardModalService.isVIP()) {
    <tag-pds3 type="dark" color="info" class="wk-cm__tag-active"> VIP </tag-pds3>
}
@if (cardModalService.currentCard()?.originalId) {
    <tag-pds3 class="wk-cm__tag-dup" type="dark"> {{ "Dashboard.Dup" | translate }} </tag-pds3>
}
